export default "/images/vendor/flag-icon-css/flags/1x1/vu.svg?80c6f8ab84839cdf4618414c522e3ce9";